import { useSelector } from 'react-redux';
import { languageSelectId } from '@common/BurgerNavigation/constants/languageSelect';
import { storeSelectId } from '@common/BurgerNavigation/constants/storeSelect';
import { getMenuItemTheme } from '@common/BurgerNavigation/helpers/getMenuItemTheme';
import { selectUsername } from '@common/Customer/selectors';
import { useConfig } from '@common/Hooks/useConfig';
import useRouteFormatter from '@common/Hooks/useRouteFormatter';
import { useTranslation } from '@common/Hooks/useTranslation';
import { hasMultipleLanguages } from '@helpers/hasMultipleLanguages';
import { isFeatureActive } from '@helpers/index';
import { CUSTOMER_DASHBOARD, CUSTOMER_LOGIN } from '@routes';

export const useMenu = (objCustomerServicePageUuis, serviceSection, currentNav, navClicked, languages) => {
    const config = useConfig();
    const translate = useTranslation();
    const formatRoute = useRouteFormatter();
    const customerUsername = useSelector(selectUsername);
    const dashboard = formatRoute(CUSTOMER_DASHBOARD);
    const login = formatRoute(CUSTOMER_LOGIN);
    // get the keys for customer service title and customer service page
    const { titleUuid, pageUuid } = objCustomerServicePageUuis;
    const { children } = currentNav;
    const { customerService } = serviceSection;
    const shipping = translate('navigation.headline.shipping');
    const language = translate('product.details.language.label');
    const storeCountry = translate(`header.store_country.${config.store}`);
    const storeLanguage = translate(`header.store_language.${config.store}`);
    const hasLanguages = isFeatureActive('PLT-26652-add-lang-select-desktop', config);

    const defaultTheme = 'mod13';
    customerService.icon = 'palette_phone';
    customerService.theme = defaultTheme;

    //  We need to use the keys titleUuid and pageUuid because the key is used to identified which object is clicked.
    const menu = {
        ...children
    };

    // needed to for correct menu items order
    if (menu[titleUuid]) {
        delete menu[titleUuid];
    }

    if (menu[pageUuid]) {
        delete menu[pageUuid];
    }

    Object.keys(menu).forEach((key) => {
        const menuItem = menu[key];

        menuItem.theme = getMenuItemTheme(menuItem);

        if ([2, 3].indexOf(menuItem.lvl) > -1) {
            menuItem.theme = defaultTheme;
            menuItem.hasArrow = true;
        }

        if (menuItem.lvl === 1) {
            menuItem.hasArrow = false;
            menuItem.theme = 'mod14';
        }
    });

    menu.divider = {
        theme: 'divider'
    };

    menu[pageUuid] = { ...customerService, hasArrow: true };

    if (customerUsername) {
        menu.account_2 = {
            name: customerUsername,
            theme: defaultTheme,
            icon: 'palette_profile',
            url: dashboard,
            URLPrefix: '',
            hasArrow: true
        };
    } else {
        menu.account_2 = {
            name: translate('navigation.headline.myaccount'),
            theme: defaultTheme,
            icon: 'palette_profile',
            url: login,
            URLPrefix: '',
            hasArrow: true
        };
    }

    if (navClicked !== storeSelectId) {
        menu.storeSelect = {
            name: `${shipping}: ${storeCountry}`,
            icon: 'palette_delivery',
            url: '#change_country_content',
            URLPrefix: '',
            theme: defaultTheme,
            hasArrow: true
        };
    }

    if (
        navClicked !== languageSelectId
        && hasMultipleLanguages(hasLanguages ? languages[config.store] : false)
    ) {
        menu.languageSelect = {
            name: `${language}: ${storeLanguage}`,
            url: '#change_language_content',
            icon: 'palette_globe',
            URLPrefix: '',
            theme: defaultTheme,
            hasArrow: true
        };
    }

    return menu;
};
